// extracted by mini-css-extract-plugin
export default {"PFSWaveContainer":"PFSWaveContainer_PFSWaveContainer__Zx3cj","ContentWrapper":"PFSWaveContainer_ContentWrapper__BgCxQ","WaveContainer":"PFSWaveContainer_WaveContainer__Mq8sX"};